module.exports = __webpack_public_path__ + "files/c6d26ca38b092453619b95f3f40311cf.png";